import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {MapFilterBooksyAction, MapFilterSteamPodAction, MapLoadMarkersAction, MapSetOptionsAction} from './map.actions';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {find} from 'lodash-es';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

export class MapStateModel {
  public items: any[];
  public center: any;
  public distance: any[];
  public zoom: number;
  public booksy: boolean;
  public steam_pod: boolean;
}

const defaults = {
  items: [],
  distance: [],
  center: null,
  zoom: null,
  booksy: null,
  steam_pod: null,
};

@State<MapStateModel>({
  name: 'map',
  defaults
})
@Injectable()
export class MapState {

  constructor(
    private readonly http: HttpClient
  ) {
  }

  @Selector()
  public static steam_pod({ steam_pod }: MapStateModel): boolean {
    return steam_pod;
  }

  @Selector()
  public static booksy({ booksy }: MapStateModel): boolean {
    return booksy;
  }

  @Selector()
  public static zoom({ zoom }: MapStateModel): any {
    return zoom;
  }

  @Selector()
  public static center({ center }: MapStateModel): any {
    return center;
  }

  @Selector()
  public static items({ items, distance }: MapStateModel): any[] {
    return items.map((item: any) => ({
      ...item,
      distance: find(distance, {id: item.id})?.distance
    }));
  }

  @Action(MapLoadMarkersAction)
  public fetchMapMarkers(ctx: StateContext<MapStateModel>): Observable<any> {
    return this.http.get(`${environment.apiUrl}/salonexpert-consumer/saloon/googlemap/points`)
      .pipe(
        tap(data => {
          data.forEach(salon => {
            salon.booksy = !!salon.booksy_id;
          });
          ctx.patchState({
            items: data
          });
        })
      );
  }


  @Action(MapSetOptionsAction)
  public updateCenter(ctx: StateContext<MapStateModel>, conf: MapSetOptionsAction): void {
    const data = ctx.getState();
    const distances = [];
    if (data.center) {
      data.items.forEach((item: any) => {
        const distance = this.getDistance(data.center, {lat: item.latitude, lng: item.longitude});
        distances.push({
          id: item.id,
          distance
        });
      });
    }
    ctx.patchState({
      center: conf.center,
      zoom: conf.zoom,
      distance: distances,
    });
  }

  @Action(MapFilterBooksyAction)
  public mapFilterBooksyAction(ctx: StateContext<MapStateModel>, conf: MapFilterBooksyAction): void {
    ctx.patchState({
      booksy: conf.booksy,
    });
  }

  @Action(MapFilterSteamPodAction)
  public mapFilterSteamPodAction(ctx: StateContext<MapStateModel>, conf: MapFilterSteamPodAction): void {
    ctx.patchState({
      steam_pod: conf.steamPod,
    });
  }

  private getDistance(location1, location2) {
    const lat1 = location1.lat();
    const lon1 = location1.lng();

    const lat2 = location2.lat;
    const lon2 = location2.lng;

    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;

    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }
  }
}
